import React from 'react';
import RatePlanItem from './RatePlanItem';
import ProductItem from './ProductItem';
import ArticlesSection from './ArticlesSection';
import SupportSection from './SupportSection';
import { GoArrowUpLeft } from 'react-icons/go';
import './SectionsLayout.scss';

const SectionsLayout = ({
                            apiData,
                            translation,
                            query,
                            viewAllRedirection,
                            originUrlRedirection,
                            handleProductClick,
                            handleInputChange
                        }) => {
    const parseTitle = (title) => {
        const parts = (title || '').split(/(<em>.*?<\/em>)/g);
        return parts.map((part, index) =>
            part.startsWith("<em>") ? (
                <span key={index} style={{ color: '#004B87' }}>
                {part.replace(/<\/?em>/g, "")}
            </span>
            ) : (
                part
            )
        );
    };


    return (
        <div className="sections-layout">
            {(apiData?.products || apiData?.services) && (
                <div className="left-section">
                    {apiData?.products?.length > 0 &&<>
                        {apiData?.products && <h4>
                            {translation('products')}(
                            {apiData?.totalProducts})
                        </h4>}
                        <ul>
                            {apiData?.products.map((item, index) => {
                                return (
                                    <ProductItem
                                        key={index}
                                        item={item}
                                        originUrlRedirection={originUrlRedirection}
                                        translation={translation}
                                        handleProductClick={handleProductClick}
                                    />
                                );
                            })}
                        </ul>
                        <button
                            className="view-all-products" style={{width: "100%"}}
                            onClick={() => viewAllRedirection('products')}
                        >
                            {translation('view_all_products')}
                        </button>
                    </>}
                    <pre/>
                    {apiData?.services?.length > 0 && <>
                        {apiData?.services?.length > 0 && <h4>
                            {translation('ratePlans')}(
                            {apiData?.totalServices})
                        </h4>}
                        <ul>
                            {apiData?.services.map((item, index) => {
                                return (
                                    <RatePlanItem
                                        key={index}
                                        item={item}
                                        originUrlRedirection={originUrlRedirection}
                                        translation={translation}
                                        handleProductClick={handleProductClick}
                                    />
                                );
                            })}
                        </ul>
                        {apiData?.services?.length > 0 && <button
                            className="view-all-products" style={{width: "100%"}}
                            onClick={() => viewAllRedirection('rateplans')}
                        >
                            {translation('view_all_services')}
                        </button>}
                    </>}

                </div>
            )}

            <div className="middle-section">
                <ArticlesSection
                    articles={apiData.articles}
                    translation={translation}
                    originUrlRedirection={originUrlRedirection}
                    viewAllRedirection={viewAllRedirection}
                    totalArticles={apiData?.totalArticles}

                />

                <SupportSection
                    support={apiData.support}
                    translation={translation}
                    viewAllRedirection={viewAllRedirection}
                    total ={apiData?.totalSupport}
                />
            </div>

            {apiData.filters && apiData.filters.length > 0 && (
                <div className="right-section">
                    {apiData?.listingFilters.map((filter, index) => (
                        <div key={index}>
                            <h4>{filter.title}</h4>
                            <ul>
                                {filter.items.map((item, idx) => (
                                    <li key={idx}>
                                        <a
                                            className="search-item"
                                            style={{ textDecoration: 'none' }}
                                            href={originUrlRedirection + item?.url}
                                        >
                                            {parseTitle(item.title)} {item?.aggregate && <a style={{ color: '#626262' }}>({item?.aggregate})</a>}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                    {apiData?.filters.map((filter, index) => (
                        <div key={index}>
                            <h4>{filter.title}</h4>
                            <ul>
                                {filter.items.map((item, idx) => (
                                    <li key={idx}>
                                        <a
                                            className="search-item"
                                            style={{ textDecoration: 'none' }}
                                            href={originUrlRedirection + item?.url}
                                        >
                                            {parseTitle(item.title)} {item?.aggregate && <a style={{ color: '#626262' }}>({item?.aggregate})</a>}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}

                    {apiData.hotSearches && apiData.hotSearches.length > 0 && (
                        <>
                            <h4>{translation('hotSearches')}</h4>
                            <ul>
                                {apiData.hotSearches.map((search, index) => (
                                    <li key={index}>
                                        <button
                                            className="search-item"
                                            onClick={() => {
                                                handleInputChange({ target: { value: search } });
                                            }}
                                        >
                                            <GoArrowUpLeft /> {parseTitle(search)}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default SectionsLayout;
